module.exports = __webpack_public_path__ + "img/header-engagementRingsFastDelivery.d004492.jpg";